export default "__VITE_ASSET__YBx98rI5__"